import {
  ATTACHMENT_TYPE_SUB_DRIVER,
  ATTACHMENT_TYPE_PARENT,
  ATTACHMENT_TYPE_PICKUP_ROUTE,
  ATTACHMENT_TYPE_DROP_ROUTE
} from '@/config'

export default {
  retrieveAttachmentList (state, payload) {
    state.attachmentList = payload.attachmentList
  },

  retrieveAttachmentUserList (state, payload) {
    state.attachmentUserList = payload.attachmentUserList
    state.attachmentForParentList = []
    state.attachmentForSubList = []
    state.attachmentForRouteList = []
    for (const [, value] of Object.entries(state.attachmentUserList)) {
      value.isEditState = false
      value.newFile = File
      value.newTitle = value.title
      if (value.type === ATTACHMENT_TYPE_PARENT) {
        state.attachmentForParentList.push(value)
      }
      if (value.type === ATTACHMENT_TYPE_SUB_DRIVER) {
        state.attachmentForSubList.push(value)
      }
      if (value.type === ATTACHMENT_TYPE_PICKUP_ROUTE) {
        state.attachmentForRouteList.push(value)
      }
      if (value.type === ATTACHMENT_TYPE_DROP_ROUTE) {
        state.attachmentForDropRouteList.push(value)
      }
    }
  },

  addAttachmentUserToList(state, payload) {
    payload.attachmentUserInfo.isEditState = false
    payload.attachmentUserInfo.newFile = File
    payload.attachmentUserInfo.newTitle = payload.attachmentUserInfo.title
    // payload.attachmentUserInfo.created_at = payload.attachmentUserInfo.created_at
    payload.attachmentUserInfo.type = parseInt(payload.attachmentUserInfo.type)
    state.attachmentUserList.push(payload.attachmentUserInfo)

    if (payload.attachmentUserInfo.type === ATTACHMENT_TYPE_PARENT) {
      state.attachmentForParentList.push(payload.attachmentUserInfo)
    }

    if (payload.attachmentUserInfo.type === ATTACHMENT_TYPE_SUB_DRIVER) {
      state.attachmentForSubList.push(payload.attachmentUserInfo)
    }

    if (payload.attachmentUserInfo.type === ATTACHMENT_TYPE_PICKUP_ROUTE) {
      state.attachmentForRouteList.push(payload.attachmentUserInfo)
    }

    if (payload.attachmentUserInfo.type === ATTACHMENT_TYPE_DROP_ROUTE) {
      state.attachmentForDropRouteList.push(payload.attachmentUserInfo)
    }
  },

  addAttachmentToList (state, payload) {
    state.attachmentList.push(payload.attachmentInfo)
  },

  addAttachmentUserToListRoute (state, payload) {
    state.pickupRouteList[payload.data.index].isEditState = false
    state.pickupRouteList[payload.data.index].newFile = File
    state.pickupRouteList[payload.data.index].file_url = payload.attachmentUserInfo.file_url
    state.pickupRouteList[payload.data.index].created_at = payload.attachmentUserInfo.created_at
    state.pickupRouteList[payload.data.index].attachment_id = payload.attachmentUserInfo.id
  },
  addAttachmentUserToListDropRoute (state, payload) {
    state.dropRouteList[payload.data.index].isEditState = false
    state.dropRouteList[payload.data.index].newFile = File
    state.dropRouteList[payload.data.index].file_url = payload.attachmentUserInfo.file_url
    state.dropRouteList[payload.data.index].created_at = payload.attachmentUserInfo.created_at
    state.dropRouteList[payload.data.index].attachment_id = payload.attachmentUserInfo.id
  },
  getAttachmentInfo (state, payload) {
    state.attachmentInfo = payload.attachmentInfo
  },
  getAttachmentUserInfo (state, payload) {
    // state.attachmentInfo = payload.attachmentInfo
    var key = ''
    if (payload.attachmentUserInfo.type === ATTACHMENT_TYPE_PARENT) {
      key = 'attachmentForParentList'
    } else if (payload.attachmentUserInfo.type === ATTACHMENT_TYPE_SUB_DRIVER) {
      key = 'attachmentForSubList'
    } else if (payload.attachmentUserInfo.type === ATTACHMENT_TYPE_PICKUP_ROUTE) {
      key = 'attachmentForRouteList'
    } else {
      key = 'attachmentForDropRouteList'
    }

    var index = state[key].findIndex(x => x.id == payload.attachmentUserInfo.id)
    state[key][index].title = payload.attachmentUserInfo.title
    state[key][index].newTitle = payload.attachmentUserInfo.title
    state[key][index].file_url = payload.attachmentUserInfo.file_url
    state[key][index].newFile = File

  },
  deleteAttachment (state, payload) {
    state.attachmentList.splice(payload.attachmentInfo.index, 1);
  },

  deleteAttachmentUser (state, payload) {
    let index = state[payload.attachmentUserInfo.type].findIndex((item) => {
      return item.id === payload.attachmentUserInfo.attachment_id
    })

    if (index !== -1) {
      state[payload.attachmentUserInfo.type].splice(index, 1);
    }
  },

  retrievePickupRouteList(state, payload) {
    state.pickupRouteList = payload.pickupRouteList
  },

  retrieveDropRouteList(state, payload) {
    state.dropRouteList = payload.dropRouteList
  }
}
